<div class="shell">
  <aside class="nav desktop-nav">
    <div class="brand">Command Center</div>
    <nav>
      <!-- Triage left the nav (2026-06-12): Claude IS the triage — unambiguous
           signals auto-activate; ambiguous ones surface as "your call" rows on
           Today. The /triage page stays reachable for inspection/deep links. -->
      <a routerLink="/plan" routerLinkActive="active">Today</a>
      <a routerLink="/prospects" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }">Prospects</a>
      <a routerLink="/notebooks" routerLinkActive="active">Notebooks</a>
      <a routerLink="/compliance" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }">Compliance</a>
      <a routerLink="/research" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }">Research</a>
    </nav>
    <div class="who">
      <a routerLink="/settings" routerLinkActive="active" class="settings-link">Settings</a>
      <div class="name">{{ auth.displayName() }}</div>
      <button (click)="auth.logout()">Sign out</button>
    </div>
  </aside>

  <main class="content">
    <app-budget-banner />
    <router-outlet />
  </main>

  <!-- Mobile bottom-tab nav: capture lives in the COS bar (attach button +
       paste), and triage is Claude's job now — ambiguous signals surface as
       one-tap rows on Today. Mobile is the directive list + pulling someone up. -->
  <nav class="mobile-nav">
    <a routerLink="/plan" routerLinkActive="active" class="primary">Today</a>
    <a routerLink="/prospects" routerLinkActive="active">Prospects</a>
  </nav>

  <!-- Chief-of-Staff bar — fixed bottom, every page. Owns its own positioning. -->
  <app-cos-bar />
</div>
